<script setup lang="ts">
import AddToCalendarButton from './AddToCalendarButton.vue';
import { useOrigin } from '~/shared/lib/useOrigin';

const props = defineProps<{
  eventId: number;
  eventUrl: string | null;
  eventName: string;
  hasTimepadRegistration?: boolean;
  isParticipationDisabled?: boolean;
  onParticipationClick?: (event: Event) => void;
  showParticipationButton?: boolean;
  showCalendarButton?: boolean;
}>();

const route = useRoute();
const origin = useOrigin();

const pageUrl = computed(() => `${origin}${route.fullPath}`);
const encodedPageUrl = computed(() => encodeURIComponent(pageUrl.value));
const encodedEventName = computed(() => encodeURIComponent(props.eventName));
</script>
<template>
  <div :class="$style.footer">
    <div :class="$style.left">
      <AddToCalendarButton v-if="showCalendarButton" :event-id="eventId" />
      <div :class="$style.share">
        <span :class="$style.shareLabel">Поделиться:</span>
        <div :class="$style.socials">
          <a
            :href="`https://telegram.me/share/url?url=${encodedPageUrl}&text=${encodedEventName}`"
            target="_blank"
            rel="noopener noreferrer"
            :class="$style.socialLink"
            aria-label="Поделиться в Telegram"
          >
            <Icon name="my-icon:i-social-tg" :size="24" />
          </a>
          <a
            :href="`https://vk.com/share.php?url=${encodedPageUrl}&title=${encodedEventName}`"
            target="_blank"
            rel="noopener noreferrer"
            :class="$style.socialLink"
            aria-label="Поделиться во ВКонтакте"
          >
            <Icon name="my-icon:i-social-vk" :size="24" />
          </a>
        </div>
      </div>
    </div>
    <Button
      v-if="showParticipationButton"
      theme="red"
      size="xl"
      :disabled="isParticipationDisabled"
      :to="hasTimepadRegistration ? undefined : eventUrl || undefined"
      :target="hasTimepadRegistration ? undefined : '_blank'"
      :class="$style.cta"
      @click="onParticipationClick"
    >
      Принять участие
    </Button>
  </div>
</template>

<style module lang="scss">
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.left {
  display: flex;
  align-items: center;
  gap: var(--space-5x);
}

.share {
  display: flex;
  align-items: center;
  gap: var(--space-1-5x);
}

.shareLabel {
  @include text_caption1_caps;
  color: var(--color-black-2);
}

.socials {
  display: flex;
  align-items: center;
  gap: var(--space-1-5x);
}

.socialLink {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  text-decoration: none;

  rect {
    fill: var(--color-gray-bg);
  }
}

.cta {
  width: 216px;
  flex-shrink: 0;
}

@media (max-width: 1379px) {
  .footer {
    padding-left: 20px;
    padding-right: 20px;
  }
}

@media (max-width: 767px) {
  .left {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}

@media (max-width: 599px) {
  .shareLabel {
    font-size: 8px;
    letter-spacing: 0.8px;
  }

  .cta {
    width: 141px;
    height: auto;
    min-height: 40px;
    padding: 7px 20px;
    font-size: 12px;
    line-height: 1.4;
    white-space: nowrap;
  }
}
</style>
